import booking from './ja/booking.ja';
import completeProfile from './ja/completeProfile.ja';
import components from './ja/component.ja';
import createBusinessProfile from './ja/createBusinessProfile.ja';
import forgetPassword from './ja/forgetPassword.ja';
import general from './ja/general.ja';
import pages from './ja/pages.ja';
import profile from './ja/profile.ja';
import resetPassword from './ja/resetPassword.ja';
import sendPasswordSuccessfully from './ja/sendPasswordSuccessfully.ja';
import sendTicket from './ja/sendTicket.ja';
import sendVerification from './ja/sendVerification.ja';
import user from './ja/user.ja';
import verificationCheck from './ja/verificationCheck.ja';
import ticket from './ja/ticket.ja';
import createBill from './ja/createBill.ja';
import profileDepartment from './ja/profileDepartment.ja';
import profileAccounts from './ja/profileAccounts.ja';
import commissionManagement from './ja/commissionManagement.ja';
import profileCredit from './ja/profileCredit.ja';
import profileMobile from './ja/profileMobile.ja';
import rules from './ja/rules.ja';
import privacy from './ja/privacy.ja';
import tour from './ja/tour.ja';
import landing from './ja/landing.ja';
import otherOption from './ja/otherOption.ja';
export default {
  ...booking,
  ...completeProfile,
  ...components,
  ...createBusinessProfile,
  ...forgetPassword,
  ...general,
  ...pages,
  ...profile,
  ...resetPassword,
  ...sendPasswordSuccessfully,
  ...sendTicket,
  ...sendVerification,
  ...verificationCheck,
  ...user,
  ...ticket,
  ...createBill,
  ...profileDepartment,
  ...profileAccounts,
  ...commissionManagement,
  ...profileCredit,
  ...profileMobile,
  ...rules,
  ...privacy,
  ...tour,
  ...landing,
  ...otherOption,
};
